import { render, staticRenderFns } from "./wbMembershipCard.vue?vue&type=template&id=55b9cc59&scoped=true&"
import script from "./wbMembershipCard.vue?vue&type=script&lang=js&"
export * from "./wbMembershipCard.vue?vue&type=script&lang=js&"
import style0 from "./wbMembershipCard.vue?vue&type=style&index=0&id=55b9cc59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b9cc59",
  null
  
)

export default component.exports